var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "profile" }, [
    _c("img", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showImage,
          expression: "showImage"
        }
      ],
      ref: "image",
      staticClass: "profile__image",
      attrs: { src: _vm.imageSrc, height: _vm.height, width: _vm.width }
    }),
    !_vm.showImage
      ? _c("div", { staticClass: "profile__initials" }, [
          _vm._v(" " + _vm._s(_vm.userInitials) + " ")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }